import React, { useState } from "react";
import { Router, Route, match } from "react-router-dom";
import { createBrowserHistory, History } from "history";
import { ReactQueryConfigProvider } from "react-query";

import useInternalAxiosConfig from "fe-shared/src/hooks/useInternalAxiosConfig";
import queryConfig from "fe-shared/src/helpers/queryConfig";

import { INTERNAL_CLIENT_ID } from "fe-shared/src/consts";

import { User, UserInfo } from "fe-shared/src/types/domain";
import { NotificationsContainer } from "fe-shared/src/components";

import Requests from "routes/Requests";
import RequestDetails from "routes/RequestDetails";

import UserContext from "contexts/userContext";

import styles from "./App.module.scss";

interface Props {
  history?: History;
  match?: match<{}>;
  apiBaseUrl?: string;
  user?: {
    data: User;
  };
  setUserData?: (data: UserInfo | null) => void;
  refreshTokenUrl?: string;
  forbiddenCallback?: () => void;
  sessionId?: string;
}

const defaultProps = {
  setUserData: (data: UserInfo | null) => data,
};

const App = (props: Props) => {
  const {
    apiBaseUrl,
    user,
    setUserData = defaultProps.setUserData,
    refreshTokenUrl,
    forbiddenCallback,
    sessionId,
  } = props;

  const matchUrl = props.match?.url || "";
  const history = props.history || createBrowserHistory();
  const [lastOpenedRequestId, setLastOpenedRequestId] = useState<string | null>(
    null
  );
  const isReady = useInternalAxiosConfig(
    user,
    setUserData,
    apiBaseUrl,
    refreshTokenUrl,
    forbiddenCallback,
    sessionId,
    INTERNAL_CLIENT_ID
  );

  if (!isReady) {
    return null;
  }
  return (
    <ReactQueryConfigProvider config={queryConfig}>
      <UserContext.Provider value={user?.data}>
        <Router history={history}>
          <div className={styles.etRequest}>
            <Route path={matchUrl} exact>
              <Requests
                lastOpenedRequestId={lastOpenedRequestId}
                clearLastOpenedRequestId={() => setLastOpenedRequestId(null)}
              />
            </Route>
            <Route path={`${matchUrl}/:requestNumber`}>
              <RequestDetails setLastOpenedRequestId={setLastOpenedRequestId} />
            </Route>
          </div>
        </Router>
        <NotificationsContainer />
      </UserContext.Provider>
    </ReactQueryConfigProvider>
  );
};

export default App;
